<!-- * * * * * * * * * *
PAYMENT GRID
* * * * * * * * * * * * * -->



<ng-container>
    <div 
        *ngIf="this.rowsReturned === -1"
            style="margin:0 auto;" 
            mode="indeterminate"
        >
        <div class="spinner-wrapper">
            <mat-spinner></mat-spinner>
        </div>

    </div>


  
    <div *ngIf ="rowsReturned > 0">
        
        <div class="margin-left:30px;margin-bottom:10px;">
            
           
            <div class="row" style="width:100%">

                <div class="col-10">
                    <button class="btn btn-primary mt-3 ace-blue" 
                        style="margin-left:20px;" 
                        (click)="onSubmitPayments()"  
                        
                        [disabled]="pendingPayments.length === 0"
                        >
                        Submit Payments
                    </button>
                </div>

                <div class="col-2" style="padding-right:10px;">
                    <mat-accordion class="example-headers-align" multi style="position:relative; top: 10px;">
                        <mat-expansion-panel>
                          <mat-expansion-panel-header style="background-color: #003087;color:white;">
                            <mat-panel-title>
                              <span style="color:white;font-weight:bold;font-size:16px">QSR Grid Options</span>
                            </mat-panel-title>
                            <!-- <mat-panel-description>
                              Adjust Font and Columns
                              <mat-icon>build</mat-icon>
                            </mat-panel-description> -->
                          </mat-expansion-panel-header>
                          <div class="row">
                            <div class="col-12">
                                <div class="row" style="position:relative;top:5px;margin-bottom:5px;">
                                    <span style="font-weight:bold;margin-top:5px;">Adjust font size:</span>
                                    <div class="col-6">
                                        <button style="margin-left:15px;" mat-icon-button color="primary" aria-label="Decrease Font Size"  (click)="onDecreaseFontSize()">
                                            <mat-icon class="icon_display_small" style="color: #003087;">text_decrease</mat-icon>
                                        </button>
                                    </div>
                                    <div class="col-6">
                                        <button mat-icon-button color="primary" aria-label="Increase Font Size"  (click)="onIncreaseFontSize()">
                                            <mat-icon class="icon_display_large"  style="color: #003087;">text_increase</mat-icon>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12" style="height:125px;">
                                <hr />
                                <span style="font-weight:bold;">Choose QSR Display Style:</span>
                                <select id="selectQSRLayout"  class="form-select" 
                                aria-label="QSR Grid Layout Selection" 
                                style="margin-top:15px;font-size:12px;width:200px;margin-right:5px;position:relative;top:-5px;margin-bottom:5px;" 
                                (change)="onToggleShowGridColumns()"
                                [ngModel]="gridViewSelection">
                                <option [value]="0" >
                                    Full View
                                </option>
                                <option [value]="1" >
                                    Payment View
                                </option>
                                <option [value]="2" >
                                    Aging View
                                </option>
                                </select>
                            </div>
                           
                            <!-- <div class="6">
                                <button mat-icon-button color="primary" aria-label="Increase Font Size" style="margin-top:25px;"  matTooltip="Download Invoices to Microsoft Excel">
                                    <mat-icon class="icon_display_large"  style="color: #003087;">cloud_download</mat-icon>
                                </button>
                            </div> -->
                          </div>
                          
                        </mat-expansion-panel>
                    </mat-accordion>
                </div>

                <!-- <div class="col-2">
                   
                </div>
              
                <div class="col-1">
                   
                </div> -->

            </div>
           

            
            <div style="margin-left:20px;margin-top:10px;" *ngIf="pendingPayments.length > 0">Pending Payments ({{pendingPayments.length}})</div>
            <mat-tab-group class="ml-4 mr-4" style="margin-left:20px;margin-right:20px;margin-top:20px;margin-bottom:20px;" (selectedIndexChange)="onQuickSearchResultsTabIndexChanged($event)" (selectedTabChange)="onQuickSearchResultsTabChanged($event.index)">
                <mat-tab style="border: 5px;">
                    <ng-template mat-tab-label>
                        {{quickSearchResults.length}} Invoice(s) Found
                    </ng-template>

                  
                    <div class="spinner-wrapper" style="margin-top:40px;" *ngIf="areBatchPaymentsProcessing">
                        <mat-spinner [diameter]="100"></mat-spinner>
                    </div>

                    <div class="spinner-wrapper" style="margin-top:40px;" *ngIf="areBatchPaymentsProcessing">
                        <span style="margin-top:30px;font-size:18px;font-weight:bold;">Invoice Payments are Processing...</span>
                    </div>

                    <div *ngIf="batchInvoiceErrorMessage !==''">
                        <div  class="payment-error-display"><mat-icon style="transform: scale(2);color:red" >error</mat-icon></div>
                        <div  class="payment-error-display">The following payments didn't process.  Please review and try again.</div>
                        <div  class="payment-error-display">{{batchInvoiceErrorMessage}}</div>

                        <div  class="payment-error-display">
                            <button class="btn btn-primary mt-3 ace-blue" 
                            (click)="onCloseBatchPaymentInvoiceError()"  
                            >
                                Return to Invoice List</button>
                        </div>
                    </div>
                    

                    <!-- This is the Grid View that displayed all columns -->
                    <ng-container *ngIf = "gridViewSelection === 0">
                        <div *ngIf="!areBatchPaymentsProcessing && batchInvoiceErrorMessage === ''" class="mat-elevation-z8" style="margin-left:20px;margin-top:20px; margin-right:20px;height:70vh;" >
                            <table matSort (matSortChange)="sortInvoiceData($event)" style="width:100%;margin-left:2px;margin-right:2px;margin-top:10px;"> 
                                <thead style="position:sticky !important;height:30px; overflow-y: auto;top:0px;background-color:gray">
                            <tr  class="grid-headers">
                                <th mat-sort-header="queued" class="invoice-header-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}">Pmt Queued</th>
                                <th mat-sort-header="invoiceDate" class="invoice-header-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}">Rev Date</th>
                                <th mat-sort-header="invoiceNumber" class="invoice-header-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}">Invoice No</th>
                                <th mat-sort-header="rate" class="invoice-header-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}">Amount</th>
    
                                <ng-container *ngIf="showAllGridColumns === true">
                                    <th mat-sort-header="cardNo" class="invoice-header-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}">Card No</th> 
                                </ng-container>
                                <th mat-sort-header="customerName" class="invoice-header-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}">Parker</th>
                                <th mat-sort-header="companyName" class="invoice-header-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}">Company</th>
                                <ng-container *ngIf="showAllGridColumns === true">
                                <th mat-sort-header="created" class="invoice-header-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}">Created</th>
                                <th mat-sort-header="dueDate" class="invoice-header-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}">Due Date</th>
                                <th mat-sort-header="delivery" class="invoice-header-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}">Delivery</th>
                                <th mat-sort-header="dateSent" class="invoice-header-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}">Date Sent</th>
                                </ng-container>
                                <th mat-sort-header="paymentType" class="invoice-header-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}">Payment Type</th>
                                <th mat-sort-header="paymentAmount" class="invoice-header-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}">Payment Amt</th>
                                <th mat-sort-header="referenceNumber" class="invoice-header-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}">Ref No.</th>
                                <ng-container *ngIf="showAllGridColumns === true">
                                    <th mat-sort-header="adjustmentAmount" class="invoice-header-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}">Adjustments</th>
                                </ng-container>
                                <th mat-sort-header="currentBalance" class="invoice-header-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}">Balance</th>
                                <th mat-sort-header="datePaid" class="invoice-header-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}">Date Paid</th>
                                <th style="margin-right:5px;" class="invoice-header-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" >Options</th>
                            </tr>
                            </thead>
                            
                            <tr *ngFor="let invoices of quickSearchResults;let rowIndex = index" 
                                style="margin-bottom:20px;background-color:red;" 
                                class="grid-rows"
                                [ngStyle]="{'background-color': getQSRRowBackgroundColor(rowIndex)}"
                                >
    
                                <td  class="invoice-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" style="margin-left:5px;">
                                    <button mat-icon-button class="mt-0 ml-2" 
                                        (click)="removePendingPaymentRecordFromGrid(rowIndex, invoices.invoiceNumber)"
                                        *ngIf="isPaymentPendingOnGrid(rowIndex)"
                                        matTooltip="Clicking this removes this pending payment." >
                                        <mat-icon style="margin-left:2px;color:black" >delete_forever</mat-icon>
                                    </button>
    
                                    <button mat-icon-button class="mt-0 ml-2" 
                                        *ngIf="isPaymentPaidOnGrid(rowIndex)" 
                                        matTooltip="This indicates a successfully appplied payment." >
                                        <mat-icon style="margin-left:2px;color:green" >done</mat-icon>
                                    </button>
    
                                    <!-- <button mat-icon-button class="mt-0 ml-2" 
                                        *ngIf="isPaymentError(rowIndex)"
                                        
                                        matTooltip="This payment failed." >
                                        <mat-icon style="margin-left:2px;color:red" >error</mat-icon>
                                    </button> -->
    
                                   
                                    <mat-icon 
                                        *ngIf="isPaymentError(rowIndex)"    
                                        class="mt-0 ml-2" 
                                        style="margin-left:2px;color:red" >error
                                    </mat-icon>
                               
    
                                    <button mat-icon-button class="mt-0 ml-2" 
                                        *ngIf="onShowGridReload(rowIndex)" 
                                        matTooltip="Refresh the data for this invoice." >
                                        <mat-icon style="margin-left:2px;" >refresh</mat-icon>
                                    </button>
                                </td>
                                <td  class="invoice-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}"  style="margin-left:5px;">{{invoices.invoiceDate | date:'shortDate'}}</td>
                                <td  class="invoice-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}"  style="width:150px;">
                                    <span class="mimic-button-hover" style="background-color:none;" (click)="onDisplayInvoice(invoices.invoiceNumber, invoices.lotNumber, invoices.entityId)" style="text-decoration:underline;">{{invoices.invoiceNumber}}</span>
                                <td  class="invoice-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" >
                                    <div *ngIf="invoices.rate >= 0">
                                    {{invoices.rate | currency}}
                                    </div>
                                    <div *ngIf="invoices.rate < 0">
                                        <span style="color:red">({{(invoices.rate * -1) | currency}})</span>
                                    </div>
                                </td>

                                <td class="invoice-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}"  >
                                        {{invoices.cardNo}}
                                    </td>
                                
                                <td  class="invoice-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" >{{invoices.customerName}}</td>

                                <td  class="invoice-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" >{{invoices.companyName}}</td>
    
                                    <td  class="invoice-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" >{{invoices.created | date:'shortDate'}}</td>
                                    <td  class="invoice-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" >{{invoices.dueDate | date:'shortDate'}}</td>
                                    <td  class="invoice-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" >{{invoices.delivery}}</td>
                                    <td  class="invoice-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" >{{invoices.dateSent | date:'shortDate'}}</td>
    
                                <td  class="invoice-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" >
                                  
                                    
                                    <ng-container *ngIf="invoices.paymentType !== ''">
                                        {{invoices.paymentType}}
                                    </ng-container>
                                    <ng-container *ngIf="invoices.paymentType === ''">
                                        <div class="row">
                                            
                                            <div class="col-10">
                                                <select id="selectPaymentType{{rowIndex}}"  class="form-select" 
                                                    aria-label="Default select example" 
                                                    style="font-size:10px;width:220px;margin-right:5px;" 
                                                    (change)="onPaymentChange(rowIndex, $event)" [ngModel]="selectedPaymentIndex"
                                                    (blur)="clearAllRowsFromActive()"
                                                    [disabled]="isPaymentPendingOnGrid(rowIndex)">
                                                    <option *ngFor="let paymentType of paymentTypes" [value]="paymentType.paymentCode" 
                                                        [selected]="paymentType.paymentDescription === defaultPaymentType"  >
                                                        {{paymentType.paymentDescription}}
                                                    </option>
                                                </select>
                                            </div>
                                            <div class="col-2">
                                                <mat-icon  *ngIf="isPaymentPendingOnGrid(rowIndex)" 
                                                    style="color: #003087;"
                                                    >lock</mat-icon>
                                            </div>
                                        </div>
                                    </ng-container>
                                   
                                </td>
    
                                <td  class="invoice-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" >
                                    <ng-container *ngIf="invoices.paymentAmount > 0">
                                        {{invoices.paymentAmount | currency}}
                                    </ng-container>
                                    <ng-container *ngIf="invoices.paymentAmount === 0">
                                        <input type="text" id="txtPaymentAmount{{rowIndex}}" max="999999.99"
                                        [disabled]="isPaymentPendingOnGrid(rowIndex)"
                                            style="margin-left:10px;margin-right:10px" 
                                            aceCurrencyPositiveNegative
                                            (focus)="setQSRRowBackgroundColor(rowIndex)"
                                            onClick="this.select();"
                                            *ngIf="isMarkedForPayment(invoices.invoiceNumber) === true"
                                            (blur)="onAddPendingPayment(rowIndex, invoices.lotNumber, invoices.invoiceNumber)"/>
                                            <span *ngIf="quickSearchResults[rowIndex].invalidPayment === true" style="color:red;font-size:9px;margin-left:10px;">
                                                <br />
                                                Invalid Payment Amount
                                            </span>
                                    </ng-container>
                                
                                </td>
                                <td  class="invoice-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" >
                                    <ng-container *ngIf="invoices.referenceNumber !== ''">
                                        {{invoices.referenceNumber}}
                                    </ng-container>
                                    <ng-container *ngIf="invoices.referenceNumber== ''">
                                        <input type="text" 
                                            id="txtReferenceNumber{{rowIndex}}" 
                                            (keyup)="onKeyPressedReferenceNumber($event)"
                                            [disabled]="isPaymentPendingOnGrid(rowIndex)"
                                            style="margin-left:10px;margin-right:10px" 
                                            (focus)="setQSRRowBackgroundColor(rowIndex)"
                                            *ngIf="isMarkedForPayment(invoices.invoiceNumber) === true"
                                            (blur)="onAddPendingPayment(rowIndex, invoices.lotNumber, invoices.invoiceNumber)" [placeholder]="referenceNumberPlaceholder"/>
                                            
                                            <span *ngIf="quickSearchResults[rowIndex].invalidReferenceNumber === true" style="color:red;font-size:9px;margin-left:10px;">
                                                    <br />
                                                    {{referenceNumberErrorMessage}}
                                            </span>
                                    </ng-container>
    
                                </td>
                                    <td  class="invoice-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" >
                                        <div *ngIf="invoices.adjustmentAmount >= 0">
                                            {{invoices.adjustmentAmount | currency}}
                                        </div>
                                        <div *ngIf="invoices.adjustmentAmount < 0">
                                            <span style="color:red">({{(invoices.adjustmentAmount * -1) | currency}})</span>
                                        </div>
                                    
                                    </td>

                                <td  class="invoice-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" >
                                    <div *ngIf="invoices.currentBalance >= 0">
                                        {{invoices.currentBalance | currency:'USD':'symbol':'1.2-2'}}
                                    </div>
                                    <div *ngIf="invoices.currentBalance < 0">
                                        <span style="color:red">({{(invoices.currentBalance * -1) | currency:'USD':'symbol':'1.2-2'}})</span>
                                    </div>
                                </td>
                                <td  class="invoice-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" >
                                    <ng-container *ngIf="invoices.datePaid.toString() !== '0001-01-01T00:00:00'">
                                       {{invoices.datePaid | date:'shortDate'}}
                                    </ng-container>
                                </td>
                                <td  class="invoice-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}"  style="margin-right:5px;">
                                    <button class="btn btn-primary btn-sm ace-blue" 
                                            
                                            (click)="launchEnableModeForInvoice(invoices.invoiceNumber, invoices.rowId)"
                                            [disabled]= "pendingPayments.length !== 0" >Enable</button>
                                </td>
                            
                            
                            </tr>
                            </table>
                        </div>
                    </ng-container>
                    <!-- END END END
                    ****** ******
                    *** END GRID VIEW DISPLAYING ALL COLUMNS -->




                     <!-- This is the Grid View that displayed columns enumerated value === 1 -->
                     <ng-container *ngIf = "gridViewSelection === 1">
                        <div *ngIf="!areBatchPaymentsProcessing && batchInvoiceErrorMessage === ''" class="mat-elevation-z8" style="margin-left:20px;margin-top:20px; margin-right:20px;height:70vh;" >
                            <table matSort (matSortChange)="sortInvoiceData($event)" style="width:100%;margin-left:2px;margin-right:2px;margin-top:10px;"> 
                                <thead style="position:sticky !important;height:30px; overflow-y: auto;top:0px;background-color:gray">
                            <tr  class="grid-headers">
                                <th mat-sort-header="queued" class="invoice-header-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}">Pmt Queued</th>
                                <th mat-sort-header="invoiceDate" class="invoice-header-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}">Rev Date</th>
                                <th mat-sort-header="invoiceNumber" class="invoice-header-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}">Invoice No</th>
                                <th mat-sort-header="rate" class="invoice-header-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}">Amount</th>
    
                            
                                <th mat-sort-header="customerName" class="invoice-header-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}">Parker</th>
                                <th mat-sort-header="companyName" class="invoice-header-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}">Company</th>
                              
                                <th mat-sort-header="paymentType" class="invoice-header-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}">Payment Type</th>
                                <th mat-sort-header="paymentAmount" class="invoice-header-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}">Payment Amt</th>
                                <th mat-sort-header="referenceNumber" class="invoice-header-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}">Ref No.</th>
                             
                                <th mat-sort-header="currentBalance" class="invoice-header-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}">Balance</th>
                                <th mat-sort-header="datePaid" class="invoice-header-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}">Date Paid</th>
                                <th style="margin-right:5px;" class="invoice-header-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" >Options</th>
                            </tr>
                            </thead>
                            
                            <tr *ngFor="let invoices of quickSearchResults;let rowIndex = index" 
                                style="margin-bottom:20px;background-color:red;" 
                                class="grid-rows"
                                [ngStyle]="{'background-color': getQSRRowBackgroundColor(rowIndex)}"
                                >
    
                                <td  class="invoice-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" style="margin-left:5px;">
                                    <button mat-icon-button class="mt-0 ml-2" 
                                        (click)="removePendingPaymentRecordFromGrid(rowIndex, invoices.invoiceNumber)"
                                        *ngIf="isPaymentPendingOnGrid(rowIndex)"
                                        matTooltip="Clicking this removes this pending payment." >
                                        <mat-icon style="margin-left:2px;color:black" >delete_forever</mat-icon>
                                    </button>
    
                                    <button mat-icon-button class="mt-0 ml-2" 
                                        *ngIf="isPaymentPaidOnGrid(rowIndex)" 
                                        matTooltip="This indicates a successfully appplied payment." >
                                        <mat-icon style="margin-left:2px;color:green" >done</mat-icon>
                                    </button>
    
                                    <!-- <button mat-icon-button class="mt-0 ml-2" 
                                        *ngIf="isPaymentError(rowIndex)"
                                        
                                        matTooltip="This payment failed." >
                                        <mat-icon style="margin-left:2px;color:red" >error</mat-icon>
                                    </button> -->
    
                                   
                                    <mat-icon 
                                        *ngIf="isPaymentError(rowIndex)"    
                                        class="mt-0 ml-2" 
                                        style="margin-left:2px;color:red" >error
                                    </mat-icon>
                               
    
                                    <button mat-icon-button class="mt-0 ml-2" 
                                        *ngIf="onShowGridReload(rowIndex)" 
                                        matTooltip="Refresh the data for this invoice." >
                                        <mat-icon style="margin-left:2px;" >refresh</mat-icon>
                                    </button>
                                </td>
                                <td  class="invoice-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}"  style="margin-left:5px;">{{invoices.invoiceDate | date:'shortDate'}}</td>
                                <td  class="invoice-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}"  style="width:150px;">
                                    <a href="https://{{urlDomain}}/Invoice/ReturnPdf/{{invoices.lotNumber}}/{{invoices.invoiceNumber}}" target="_blank">
                                        {{invoices.invoiceNumber}}
                                    </a>
                                <td  class="invoice-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" >
                                    <div *ngIf="invoices.rate >= 0">
                                    {{invoices.rate | currency}}
                                    </div>
                                    <div *ngIf="invoices.rate < 0">
                                        <span style="color:red">({{(invoices.rate * -1) | currency}})</span>
                                    </div>
                                </td>
                              
                                <td  class="invoice-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" >{{invoices.customerName}}</td>
                                <td  class="invoice-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" >{{invoices.companyName}}</td>
    
    
                                <td  class="invoice-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" >
                                  
                                    
                                    <ng-container *ngIf="invoices.paymentType !== ''">
                                        {{invoices.paymentType}}
                                    </ng-container>
                                    <ng-container *ngIf="invoices.paymentType === ''">
                                        <div class="row">
                                            
                                            <div class="col-10">
                                                <select id="selectPaymentType{{rowIndex}}"  class="form-select" 
                                                    aria-label="Default select example" 
                                                    style="font-size:10px;width:220px;margin-right:5px;" 
                                                    (change)="onPaymentChange(rowIndex, $event)" [ngModel]="selectedPaymentIndex"
                                                    (blur)="clearAllRowsFromActive()"
                                                    [disabled]="isPaymentPendingOnGrid(rowIndex)">
                                                    <option *ngFor="let paymentType of paymentTypes" [value]="paymentType.paymentCode" 
                                                        [selected]="paymentType.paymentDescription === defaultPaymentType"  >
                                                        {{paymentType.paymentDescription}}
                                                    </option>
                                                </select>
                                            </div>
                                            <div class="col-2">
                                                <mat-icon  *ngIf="isPaymentPendingOnGrid(rowIndex)" 
                                                    style="color: #003087;"
                                                    >lock</mat-icon>
                                            </div>
                                        </div>
                                    </ng-container>
                                   
                                </td>
    
                                <td  class="invoice-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" >
                                    <ng-container *ngIf="invoices.paymentAmount > 0">
                                        {{invoices.paymentAmount | currency}}
                                    </ng-container>
                                    <ng-container *ngIf="invoices.paymentAmount === 0">
                                        <input type="text" id="txtPaymentAmount{{rowIndex}}" 
                                        [disabled]="isPaymentPendingOnGrid(rowIndex)"
                                            style="margin-left:10px;margin-right:10px" 
                                            aceCurrencyPositiveNegative
                                            (focus)="setQSRRowBackgroundColor(rowIndex)"
                                            onClick="this.select();"
                                            *ngIf="isMarkedForPayment(invoices.invoiceNumber) === true"
                                            (blur)="onAddPendingPayment(rowIndex, invoices.lotNumber, invoices.invoiceNumber)"/>
                                            <span *ngIf="quickSearchResults[rowIndex].invalidPayment === true" style="color:red;font-size:9px;margin-left:10px;">
                                                <br />
                                                Invalid Payment Amount
                                            </span>
                                    </ng-container>
                                
                                </td>
                                <td  class="invoice-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" >
                                    <ng-container *ngIf="invoices.referenceNumber !== ''">
                                        {{invoices.referenceNumber}}
                                    </ng-container>
                                    <ng-container *ngIf="invoices.referenceNumber== ''">
                                        <input type="text" 
                                            id="txtReferenceNumber{{rowIndex}}" 
                                            [disabled]="isPaymentPendingOnGrid(rowIndex)"
                                            style="margin-left:10px;margin-right:10px" 
                                            aceReferenceNumberRules
                                            (focus)="setQSRRowBackgroundColor(rowIndex)"
                                            *ngIf="isMarkedForPayment(invoices.invoiceNumber) === true"
                                            (blur)="onAddPendingPayment(rowIndex, invoices.lotNumber, invoices.invoiceNumber)" [placeholder]="referenceNumberPlaceholder"/>
                                            
                                            <span *ngIf="quickSearchResults[rowIndex].invalidReferenceNumber === true" style="color:red;font-size:9px;margin-left:10px;">
                                                    <br />
                                                    {{referenceNumberErrorMessage}}
                                            </span>
                                    </ng-container>
    
                                </td>
                              
                                <td  class="invoice-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" >
                                    <div *ngIf="invoices.currentBalance >= 0">
                                        {{invoices.currentBalance | currency:'USD':'symbol':'1.2-2'}}
                                    </div>
                                    <div *ngIf="invoices.currentBalance < 0">
                                        <span style="color:red">({{(invoices.currentBalance * -1) | currency:'USD':'symbol':'1.2-2'}})</span>
                                    </div>
                                </td>
                                <td  class="invoice-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" >
                                    <ng-container *ngIf="invoices.datePaid.toString() !== '0001-01-01T00:00:00'">
                                       {{invoices.datePaid | date:'shortDate'}}
                                    </ng-container>
                                </td>
                                <td  class="invoice-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}"  style="margin-right:5px;">
                                    <button class="btn btn-primary btn-sm ace-blue" 
                                            
                                            (click)="launchEnableModeForInvoice(invoices.invoiceNumber, invoices.rowId)"
                                            [disabled]= "pendingPayments.length !== 0" >Enable</button>
                                </td>
                            
                            
                            </tr>
                            </table>
                        </div>
                    </ng-container>
                    <!-- END END END
                    ****** ******
                    *** END GRID VIEW DISPLAYING ALL COLUMNS -->



                    <!-- This is the Grid View that displayed columns enumerated value === 2 -->
                    <ng-container *ngIf = "gridViewSelection === 2">
                        <div *ngIf="!areBatchPaymentsProcessing && batchInvoiceErrorMessage === ''" class="mat-elevation-z8" style="margin-left:20px;margin-top:20px; margin-right:20px;height:70vh;" >
                            <table matSort (matSortChange)="sortInvoiceData($event)" style="width:100%;margin-left:2px;margin-right:2px;margin-top:10px;"> 
                                <thead style="position:sticky !important;height:30px; overflow-y: auto;top:0px;background-color:gray">
                            <tr  class="grid-headers">
                                <th mat-sort-header="invoiceDate" class="invoice-header-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" style="margin-left:5px;width:100px;">Rev Date</th>
                                <th mat-sort-header="invoiceNumber" class="invoice-header-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" style="width:200px;">Invoice No</th>
                                <th mat-sort-header="customerName" class="invoice-header-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}">Parker</th>
                                <th mat-sort-header="companyName" class="invoice-header-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}">Company</th>
                                <th mat-sort-header="currentBalance" class="invoice-header-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}">Balance</th>
                                <th style="margin-right:5px;" class="invoice-header-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" >Options</th>
                            </tr>
                            </thead>
                            
                            <tr *ngFor="let invoices of quickSearchResults;let rowIndex = index" 
                                style="margin-bottom:20px;background-color:red;" 
                                class="grid-rows"
                                [ngStyle]="{'background-color': getQSRRowBackgroundColor(rowIndex)}"
                                >
    
                                

                                <td  class="invoice-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}"  style="width:100px;">
                                    <span style="padding-left:10px;">{{invoices.invoiceDate | date:'shortDate'}}</span>
                                </td>

                                <td  class="invoice-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}"  style="width:150px;">
                                    <a  href="https://{{urlDomain}}/Invoice/ReturnPdf/{{invoices.lotNumber}}/{{invoices.invoiceNumber}}" target="_blank">
                                        {{invoices.invoiceNumber}}
                                    </a>
                              
                                <td  class="invoice-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" >{{invoices.customerName}}</td>
                                <td  class="invoice-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" >{{invoices.companyName}}</td>
    
    
                               
                                <td  class="invoice-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" >
                                    <div *ngIf="invoices.currentBalance >= 0">
                                        {{invoices.currentBalance | currency:'USD':'symbol':'1.2-2'}}
                                    </div>
                                    <div *ngIf="invoices.currentBalance < 0">
                                        <span style="color:red">({{(invoices.currentBalance * -1) | currency:'USD':'symbol':'1.2-2'}})</span>
                                    </div>
                                </td>
                                <td  class="invoice-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}"  style="margin-right:5px;">
                                    <button class="btn btn-primary btn-sm ace-blue" 
                                            
                                            (click)="launchEnableModeForInvoice(invoices.invoiceNumber, invoices.rowId)"
                                            [disabled]= "pendingPayments.length !== 0" >Enable</button>
                                </td>
                            </tr>
                            </table>
                        </div>
                    </ng-container>
                    <!-- END END END
                    ****** ******
                    *** END GRID VIEW DISPLAYING ALL COLUMNS ENUMERATED VALUE === 2 -->

                    

                </mat-tab>
            
                <mat-tab label="{{appliedPayments.length}} Applied Payment(s)">
                    <div *ngIf="appliedPayments.length === 0" style="margin-top:10px;margin-left:10px;">
                        <strong><span style="font-size:11;color: gray;">No recently applied payments for this lot</span></strong>
                    </div>
                    <ng-container class="ml-4" *ngIf="appliedPayments?.length">
                        <div class="mat-elevation-z8" style="margin-left:20px;margin-top:20px; margin-right:20px;" >
                        <table style="width:100%;margin-left:2px;margin-right:2px;margin-top:10px;">
                            <tr  class="grid-headers">
                            <th>
                                Invoice Number
                            </th>
                        
                            <th>
                                Payment Type
                            </th>
                            <th>
                                Amount
                            </th>
                            <th>
                                Ref No.
                            </th>
                            </tr>
                            <tr *ngFor="let payment of appliedPayments;let i = index" 
                            class="grid-rows"
                            [ngStyle]="{'background-color': getQSRRowBackgroundColor(i)}">
                                <td  class="invoice-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" >
                                    {{payment.invoiceNumber }}
                                </td>
                            
                                <td  class="invoice-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" >
                                    {{payment.paymentType}}
                                </td>
                                <td  class="invoice-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" >
                                    
                                        {{payment.paymentAmount | currency}}
                                    
                                </td>
                                <td  class="invoice-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" >
                                    {{payment.referenceNumber }}
                                </td>
                            </tr>
                        
                        </table>   
                        </div>
                    </ng-container>
            
            
                </mat-tab>
                <!-- @if(_appGeneralState.isSuperUser)
                {
                    <mat-tab>
                        <ng-template mat-tab-label>
                            <span
                                style="display:inline-flex;align-items:center;gap:8px;"
                                (mousedown)="onSendInvoicesTabInteractionStart()"
                                (touchstart)="onSendInvoicesTabInteractionStart()"
                                (click)="onSendInvoicesTabLabelClicked()"
                            >
                                <mat-icon *ngIf="isSendInvoicesTabLoading" class="tab-label-loading-icon">autorenew</mat-icon>
                                <span>Send Invoices</span>
                            </span>
                        </ng-template>
                        <ng-template matTabContent>
                            <app-send-invoices
                                [quickSearchResults]="quickSearchResults"
                                (quickSearchResultsLoading)="onSendInvoicesLoadingStateChanged($event)"
                                (formDisplayed)="onSendInvoicesFormDisplayed()"
                            ></app-send-invoices>
                        </ng-template>
                    </mat-tab>
                } -->
            </mat-tab-group>
        </div>
    </div>
</ng-container>

<!-- ===================================
END PAYMENT GRID
=================================== -->

